import * as React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { AppState } from '@halo/stores/app.state'

const sanitizePathname = (pathname: string) => pathname.split('?')[0]

const route = (redirectPath: string, props: any) =>
    !redirectPath ? <Route {...props} /> : <Redirect to={redirectPath} exact={true} from={props.path || ''} />

const getAppState = (): AppState => Container.get(AppState)

@observer
export class InternalRoute extends React.Component<any> {
    public render() {
        const appState = getAppState()
        const pathname = sanitizePathname(this.props.location.pathname)

        let redirectPath
        if (!appState.isAuthenticated) {
            redirectPath = '/'

            if (pathname !== '/') {
                redirectPath += `?redirect=${location.pathname}`
            }
        }

        return route(redirectPath, this.props)
    }
}

@observer
export class ExternalRoute extends React.Component<any> {
    public render() {
        const appState = getAppState()
        const pathname = sanitizePathname(this.props.location.pathname)
        const queryString = (this.props.location || {}).search

        let redirectPath
        const redirectRequest = queryString.match('redirect=([^&]+)')
        if (appState.isAuthenticated) redirectPath = !!redirectRequest ? redirectRequest[1] : '/'

        return route(redirectPath, this.props)
    }
}
